import { Box, Button, Typography, Skeleton, Stack } from '@mui/material'
import { useContext, useEffect } from 'react'
import { MobileContainer } from './MobileContianer'
import { ToolContext } from '../../../../../../core/context/ToolContext'
import { rqx } from '../../../../../../core/request/API'
import { env, domain } from '../../../../../../core/Env'
import { useHistory } from 'react-router-dom'
import { DirectTabLoader } from '../../../../../../core/loader/DirectTabLoader'

export const RealProperty = () => {
    const { website_state, tool_state } = useContext(ToolContext)
    const { preview, prevLoader, activeTab } = { ...website_state };
    const urlParams = new URLSearchParams(window.location.search);
    const history = useHistory()
    const company_id = tool_state.__SESSION.data.uaccess[0].company_id

    const __init = async () => {
        prevLoader.set(true);
        const primaryRes = await rqx.get(`<<tool>>/${env()}/realPropertyWebsite/read`, { company_id: company_id });
        // get website id if it has to generate "Go to Site" btn
        const pvw = await rqx.get(`<<tool>>/${env()}/templateLists/read`, { id: 2 });
        //const webId = primaryRes.length > 0 ? primaryRes[0].template_id === undefined ? "" : primaryRes[0].id : "";
        const webId = primaryRes.length > 0 ? primaryRes[0].template_id === undefined ? pvw[0].id : primaryRes[0].id : pvw[0].id;
        let designs = JSON.parse(pvw[0].designs);
        let properties = designs.property;
        let topBar = designs.top_bar;
        let siteBtns = designs.site_btns;
        const propertyData = properties.map((p) => ({
            id: p.id,
            title: { value: p.title.value },
            description: { value: p.description.value },
            location: { city: p.location.city, province: p.location.province },
            block: { value: p.block.value },
            floor_number: { value: p.floor_number.value },
            price: { value: p.price.value },
            offer_type: p.offer_type,
            property_type: p.property_type,
            coverPhoto: {
                value: p.coverPhoto.value,
                object: p.coverPhoto.object,
                name: p.coverPhoto.name,
                type: p.coverPhoto.type,
                size: p.coverPhoto.size,
                updated: false,
                stat: true,
                msg: ''
            },
            contact_details: p.contact_details,
            indoor: p.indoor,
            outdoor: p.outdoor,
            land_mark: p.land_mark,
            normal_photos: p.normal_photos,
        }));
        preview.set({
            status: primaryRes.length > 0 ? primaryRes[0].status : pvw[0].status,
            id: webId,
            template_id: pvw[0].template_id === undefined ? pvw[0].id : pvw[0].template_id,
            device_type: pvw[0].device_type,
            submit: { modal: false, type: 0, confirmed: false },
            own_domain: { value: '', stat: false, msg: '' },
            website_link: { value: '', stat: false, msg: '' },
            list: propertyData,
            top: {
                bg_color: topBar.bg_color,
                buttons: { bg: topBar.button.bg, color: topBar.button.color },
                title: { value: topBar.title.value, font_size: topBar.title.fontsize },
            },
            logo: { value: pvw[0].link, object: pvw[0].link, name: pvw[0].name, size: pvw[0].size, type: pvw[0].type, updated: false, stat: false, msg: '' },
            site_btns: { bg: siteBtns.bg, color: siteBtns.color },
            logText: { lognIn: '', logOut: '' },
            signText: { signIn: '', signOut: "SignOut" },
        });
        prevLoader.set(false);
    };

    const handleCustomize = () => {
        history.push(`/campaign/website/customization?tab=mobile&menu=property-rent`)
    }

    const gotoWebsite = async (wId) => {
        let ssoUrls = `${domain('shp').url}/psl/ws/realproperty/${window.btoa(`${company_id}`)}_${window.btoa(`${wId}`)}?type=property-rent`
        await DirectTabLoader('ShpWN', ssoUrls)
    };

    useEffect(() => {
        history.push(`/campaign/website?type=real-property&tab=list&offer_type=rent&property_type=all`)
        __init()
        // eslint-disable-next-line
    }, [])

    return (
        <Box width="100%" height="100%" mt={2}
            sx={{
                background: "linear-gradient(to bottom right, #6fb1fc, #e3e8e8, #d3efff)",
                display: 'flex',
                justifyContent: 'center',
                gap: 1,
                flexDirection: "column",
                alignItems: 'center',
                borderRadius: 2,
                py: 3
            
            }}
        >
            <Box
                width="338px"
                height="568px"
                borderRadius={2} >
                <MobileContainer activeTab={activeTab} preview={preview} history={history} prevLoader={prevLoader} urlParams={urlParams} />
            </Box>
            <Box width={450} display="flex" justifyContent="center">
                {!prevLoader.data ?
                    (
                        <Box width="100%" display="flex" alignItems="center" p={2} border="solid 1px #CECECE" borderRadius={2} bgcolor="#fff" gap="0.5rem">
                            <Typography width="100%">
                                Template &nbsp;
                                {preview.data.template_id}
                            </Typography>
                            <Stack flexDirection="row" gap="0.5rem">
                                {preview.data.status === 2 && 
                                    <Box width="6.5rem" variant="outlined" component={Button} sx={{ bgcolor: "#E8E8E8", color: "#080808", "&:hover": { bgcolor: "#E8E8E8" } }} onClick={() => gotoWebsite(preview.data.id)}>Go to Site</Box> 
                                }
                                <Box variant="outlined" component={Button} sx={{ bgcolor: "#4a90e2", color: "#fff", "&:hover": { bgcolor: "#4a90e2" }, }}
                                    onClick={() => handleCustomize()}
                                >
                                    Customize
                                </Box>
                            </Stack>
                        </Box>
                    ) : <Skeleton variant='rounded' width="100%" height={70} />}
            </Box>
        </Box>

    )
}
